import {InfiniteScrollPanel} from "../infiniteScroll.js";
import {SavedListingRepository} from "../saved-listings/SavedListingRepository.js";
import {ZIDXListingSummary} from "../base.js";
import {ZIDX} from "../standaloneLibrary.js";

export class ListingThumbnailLayout1 {
    private zidx: ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    render(ss: ZIDXListingSummary, panel: InfiniteScrollPanel): string {
        const isSaved = SavedListingRepository.getInstance(this.zidx).isSaved(ss.id);
        let arrHTML = [];
        arrHTML.push("<div title=\"View Listing\" class=\"zidxSearchResultListingImage");
        if (!panel.visible) {
            arrHTML.push(" zidxImageNotLoaded\" data-image=\"" + ss.photo + "\"");
        }
        if (panel.visible) {
            arrHTML.push("\" style=\"background-image:url('" + ss.photo + "');\"");
        }
        arrHTML.push(">");
        if (this.zidx.zidxBase.renderSaveButton) {
            arrHTML.push(`
                        <div class=\"zidxSearchResultListingSaveButton\">
                            <i title=\"Save property\" data-id='${ss.indexId+":"+ss.id}' data-unique-id='${ss.uniqueId}' saved='${isSaved}' class=\"fa ${isSaved ? 'fa-heart' : 'fa-heart-o'} zidxSearchResultSave\" aria-hidden=\"true\"></i>
                        </div>
                `);
        }
        arrHTML.push("</div>" +
            "<div class=\"zidxSearchResultListingTextContainer\">\n");

        arrHTML.push("   <div class=\"zidxSearchResultListingType\">\n" +
            "                " + ss.type + "&nbsp;\n" +
            "            </div>\n" +
            "            <div class=\"zidxSearchResultListingStatus\">\n" +
            "                " + ss.listStatus + "&nbsp;\n" +
            "            </div>\n");
        arrHTML.push("<div class=\"zidxSearchResultListingPrice\">");
        if (ss.price != 0) {
            arrHTML.push("$" + this.zidx.zidxBase.numberFormat(ss.price));
        } else {
            arrHTML.push("&nbsp;");
        }
        arrHTML.push("</div>\n");
        arrHTML.push("<div>\n");
        let specs = [];
        if (ss.bedrooms != 0) {
            specs.push("<strong>"+ss.bedrooms + "</strong> Beds &nbsp; ");
        }
        if (ss.bathrooms != 0) {
            specs.push("<strong>"+ss.bathrooms + "</strong> Baths &nbsp; ");
        }
        if (ss.halfBaths != 0) {
            specs.push("<strong>"+ss.halfBaths + "</strong> Half-Baths &nbsp; ");
        }
        if (ss.sqft != 0) {
            specs.push("<strong>"+this.zidx.numberFormat(ss.sqft) + "</strong> SQFT");
        }
        if (specs.length > 0) {
            arrHTML.push("<div class=\"zidxSearchResultListingSpecs\">" + specs.join("") + "</div>");
        }
        let unit="";
        if(ss.address2!=""){
            unit=" Unit #"+ss.address2;
        }
        arrHTML.push(
            "                <div class=\"zidxSearchResultListingAddress\">\n" +
            "                " + ss.address + unit+ "&nbsp;<br>\n" +
            "            " + ss.city + ", " + ss.state + " " + ss.postalCode + "\n" +
            "            </div>" +
            "</div>");
        arrHTML.push(
            "            <div class=\"zidxSearchResultListingButton\">\n" +
            "                View Details\n" +
            "            </div>\n" +
            "            </div>");
        return arrHTML.join("");
    }
}